import { MAX_RESOLVE_DESIGN_ASSET_IDS } from '@repo/api-contracts';

/** resolveUrls 한 번에 보낼 수 있는 상한(100)으로 나눈다. 중복은 빼고 정렬해 쿼리 키가 안정되게 한다. */
export const chunkAssetIds = (
  ids: readonly string[],
  size = MAX_RESOLVE_DESIGN_ASSET_IDS,
): string[][] => {
  const unique = [...new Set(ids)].sort();
  const chunks: string[][] = [];
  for (let start = 0; start < unique.length; start += size)
    chunks.push(unique.slice(start, start + size));
  return chunks;
};
